import { Router, CanMatchFn } from '@angular/router'
import { inject } from '@angular/core'
import { AppConfigService } from '../services/app-config.service'
import { firstValueFrom } from 'rxjs'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { DomainNameTransitionDialogComponent } from '../components/domain-name-transition-dialog/domain-name-transition-dialog.component'

export const domainNameTransitionGuard: CanMatchFn = async (route, segments) => {
  const appConfigService = inject(AppConfigService)
  const ngbModal = inject(NgbModal)
  const router = inject(Router)
  const appConfig = await firstValueFrom(appConfigService.state$)
  const domainNameTransitions = appConfig.domainNameTransitions
  const targetDomainName = domainNameTransitions?.[window.location.hostname]
  if (targetDomainName === undefined) {
    return true
  }
  const modalRef = ngbModal.open(DomainNameTransitionDialogComponent, {
    backdrop: 'static',
    keyboard: false,
    centered: true
  })
  modalRef.componentInstance.targetUrl = `${window.location.protocol}//${targetDomainName}/recap${router.routerState.snapshot.url}`
  await modalRef.result
  return true
}

